import type { FC, PropsWithChildren } from 'react'

import { twMerge } from 'tailwind-merge'

import type { TrProps } from './types'

export type TrButtonProps = TrProps & {
  onClick: () => void
  style?: React.CSSProperties
}

export const TrButton: FC<PropsWithChildren<TrButtonProps>> = ({
  children,
  className,
  style,
  onClick,
  onMouseOut,
  onMouseOver,
}) => (
  <tr
    className={twMerge('tr-button', className)}
    style={style}
    tabIndex={0}
    onKeyDown={e => {
      if (e.key === 'Enter') {
        e.preventDefault()
        onClick()
      }
    }}
    onClick={onClick}
    onMouseOver={e => onMouseOver?.(e)}
    onMouseOut={onMouseOut}
    onFocus={e => onMouseOver?.(e)}
    onBlur={e => onMouseOut?.(e)}
  >
    {children}
  </tr>
)
